import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faBars, faBan, faDeleteLeft, faSort, faSortUp, faSortDown } from "@fortawesome/free-solid-svg-icons";
import "./ListWithFiltersQS.css";
import SearchField from "../SearchField/SearchField";
import useContextMenu from "../../contexts/useContextMenu";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useNavigate, useLocation } from "react-router-dom";

/**
 * ListWithFilters component.
 *
 * @param {Object[]} data - Array of objects representing the data to be displayed in the list.
 * @param {string[]} columns - Array of strings representing the column headers of the data.
 * @param {Function} onRowClick - Callback function to be executed when a row is clicked.
 * @param {string} rowID - The key of the unique identifier in the row data.
 * @param {boolean} editableRows - If true, rows are editable.
 * @param {string[]} sortDirections - Initial sorting direction for each column (ASC, DESC, or NON).
 * @param {boolean} sortable - If true, columns are sortable.
 * @param {boolean} placeHolders - If true, use placeholders
 * @param {string[]} placeHolderList - Array or strings representing placeholders for columns
 * @param {boolean} rowIndex - If true, displays row index as the first column.
 * @param {string[]} size - Array of strings (S, M, L) indicating the width of each column.
 * @param {boolean} clearSelectedRowID - Flag to clear the selected row ID when the parent component needs it.
 * @param {Function} setClearSelectedRowID - Callback to update the clearSelectedRowID state in the parent.
 * @param {number} tabIndex - Tab index for keyboard navigation.
 */

const ListWithFilters = ({
  data,
  columns,
  onRowClick,
  rowID,
  editableRows,
  sortDirections,
  sortable,
  placeHolders,
  placeHolderList,
  rowIndex,
  size,
  clearSelectedRowID,
  setClearSelectedRowID,
  tabIndex,
  limit,
  setLimit,
  setReloadlistdata,
  duplicateurl,
}) => {
  // General
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();

  const { clicked, setClicked, points, setPoints } = useContextMenu();
  const [activeIndex, setActiveIndex] = useState();
  // function createFilterInit(keys) {
  //   const obj = Object.fromEntries(keys.map((key) => [key, ""]));
  //   return obj;
  // }

  // const [filters, setFilters] = useState(createFilterInit(columns));
  const [filters, setFilters] = useState(Object.fromEntries(columns?.map((key) => [key, ""])));

  const [filteredData, setFilteredData] = useState(data);

  const [showclearfilter, setShowclearfilter] = useState(false);

  const [selectedRowID, setSelectedRowID] = useState();

  const [editing, setEditing] = useState();

  const [editable, setEditable] = useState(editableRows || false);

  const [sortingDirections, setSortingDirections] = useState(sortDirections ? sortDirections : []);
  const [sortingDirectionsObs, setSortingDirectionsObs] = useState(sortDirections ? sortDirections : []);

  const [sortingCols, setSortingCols] = useState(columns ? columns : []);

  // const [listdata, setListData] = useState(data);

  // // Load Data on Data Change
  // useEffect(() => {
  //   setListData(data);
  // }, [data]);

  // Clear Selected Row ID from parent react element
  // useState(() => {
  //   if (clearSelectedRowID === false) {
  //     setSelectedRowID(0);
  //   }
  // }, [clearSelectedRowID]);

  // FILTER METHOD
  useEffect(() => {
    if (data && data.length && columns && columns.length > 0 && filters) {
      let result = data.filter((item) =>
        columns.every((col) => {
          return typeof item[col] === "string" && item[col] !== ""
            ? item[col]?.toLowerCase().includes(filters[col]?.toLowerCase())
            : Number(item[col])?.toFixed(3).includes(filters[col]);
        })
      );
      setFilteredData(result);
      // console.log(filteredData);
    }
  }, [filters, data]);

  const addRowToEditing = (item) => {
    // console.log(item);
    setEditing({ ...editing, [item[rowID]]: item });
  };

  const duplicateQS = async (rowID) => {
    try {
      const response = await axiosPrivate.post(`/api/qs/${duplicateurl}`, { rowID });
      if (response.data.message === "Row Duplicated") {
        // console.log("duplicated");
        setReloadlistdata((prev) => !prev);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <ul
      className='listwithfilter'
      onClick={() => {
        if (clicked) setClicked(false);
      }}
    >
      <div className='lwf-limit-bar'>
        <div>
          <span>Show:</span>
          {[
            { label: "300", value: 300 },
            { label: "1000", value: 1000 },
            { label: "No limit", value: 0 },
          ].map((opt) => (
            <span
              key={opt.label}
              className={`lwf-limit-option ${limit === opt.value ? "active" : ""}`}
              onClick={() => setLimit(opt.value)}
            >
              {opt.label}
            </span>
          ))}
        </div>
        {showclearfilter && (
          <p
            className={rowIndex ? "lwfclear" : "lwfclear lwfclearnoindex"}
            onClick={(e) => {
              setShowclearfilter(false);
              // setFilters(createFilterInit(columns));
              setFilters(Object.fromEntries(columns?.map((key) => [key, ""])));
            }}
          >
            Clear All
          </p>
        )}
      </div>

      <div className='lwffilters'>
        {rowIndex && <p style={{ width: "35px" }}></p>}

        {columns &&
          columns.map((col, index) => (
            <p
              style={
                size && size[index] === "S"
                  ? {
                      display: "flex",
                      // flexBasis: 100 / columns.length / 4 + "%",
                      flex: 1,
                    }
                  : size && size[index] === "M"
                  ? {
                      display: "flex",
                      // flexBasis: 100 / columns.length / 2 + "%",
                      flex: 2,
                    }
                  : {
                      display: "flex",
                      // flexBasis: 100 / columns.length + "%",
                      flex: 4,
                    }
              }
              key={col + "-filter"}
            >
              <input
                autoComplete='off'
                className='lwffilterinput'
                value={filters && filters[col] ? filters[col] : ""}
                onChange={(e) => {
                  setShowclearfilter(true);
                  setFilters({ ...filters, [col]: e.target.value });
                }}
                placeholder={placeHolders && placeHolderList ? placeHolderList[index] || col : ""}
                tabIndex={tabIndex && tabIndex}
              />
              {sortable && (
                <FontAwesomeIcon
                  className='lwfsorticon'
                  icon={
                    sortingDirectionsObs[index] === "ASC"
                      ? faSortUp
                      : sortingDirectionsObs[index] === "DESC"
                      ? faSortDown
                      : faSort
                  }
                  onClick={(e) => {
                    const colIndex = index;
                    const currentDir = sortingDirectionsObs[colIndex];
                    let newDir;

                    if (currentDir === "NON") newDir = "ASC";
                    else if (currentDir === "ASC") newDir = "DESC";
                    else newDir = "NON";

                    // Update direction for this column
                    const newDirections = [...sortingDirectionsObs];
                    newDirections[colIndex] = newDir;
                    setSortingDirectionsObs(newDirections);

                    // Update priority stack
                    setSortingCols((prevCols) => {
                      let updated = [...prevCols];
                      // remove column if exists
                      updated = updated.filter((c) => c !== col);
                      // add to front if ASC or DESC
                      if (newDir !== "NON") updated.unshift(col);
                      return updated;
                    });

                    // Update sortDirections with same logic
                    setSortingDirections((prev) => {
                      const idx = columns.indexOf(col);
                      const updated = [...prev];
                      updated[idx] = newDir;
                      return updated;
                    });
                  }}
                  // onClick={(e) => {
                  //   let indx = sortingCols.findIndex((it) => it === col);
                  //   sortingDirectionsObs[index] === "ASC" &&
                  //     setSortingDirectionsObs((prev) => {
                  //       return [...prev.slice(0, index), "DESC", ...prev.slice(index + 1, prev.length)];
                  //     });
                  //   sortingDirectionsObs[index] === "DESC" &&
                  //     setSortingDirectionsObs((prev) => [
                  //       ...prev.slice(0, index),
                  //       "NON",
                  //       ...prev.slice(index + 1, prev.length),
                  //     ]);
                  //   sortingDirectionsObs[index] === "NON" &&
                  //     setSortingDirectionsObs((prev) => [
                  //       ...prev.slice(0, index),
                  //       "ASC",
                  //       ...prev.slice(index + 1, prev.length),
                  //     ]);
                  //   sortingDirections[indx] === "ASC" &&
                  //     setSortingDirections((prev) => {
                  //       return [...prev.slice(0, indx), "DESC", ...prev.slice(indx + 1, prev.length)];
                  //     });
                  //   sortingDirections[indx] === "DESC" &&
                  //     setSortingDirections((prev) => [
                  //       ...prev.slice(0, indx),
                  //       "NON",
                  //       ...prev.slice(indx + 1, prev.length),
                  //     ]);
                  //   sortingDirections[indx] === "NON" &&
                  //     setSortingCols((prev) => [
                  //       ...prev.slice(0, indx),
                  //       ...prev.slice(indx + 1, prev.length),
                  //       prev[indx],
                  //     ]);
                  //   sortingDirections[indx] === "NON" &&
                  //     setSortingDirections((prev) => [
                  //       ...prev.slice(0, indx),
                  //       ...prev.slice(indx + 1, prev.length),
                  //       "ASC",
                  //     ]);
                  // }}
                />
              )}
            </p>
          ))}

        {editable && <p className='lwfRowIcons'></p>}
      </div>
      {filteredData &&
        filteredData
          // .sort((a, b) => {
          //   if (sortable) {
          //     let ind = 0;
          //     let result;
          //     if (sortingDirections[ind] === "ASC") {
          //       result =
          //         typeof a[sortingCols[ind]] === "string"
          //           ? a[sortingCols[ind]].localeCompare(b[sortingCols[ind]])
          //           : a[sortingCols[ind]] - b[sortingCols[ind]];
          //     } else if (sortingDirections[ind] === "DESC") {
          //       result =
          //         typeof a[sortingCols[ind]] === "string"
          //           ? b[sortingCols[ind]].localeCompare(a[sortingCols[ind]])
          //           : b[sortingCols[ind]] - a[sortingCols[ind]];
          //     }
          //     do {
          //       ind = ind + 1;
          //       if (sortingDirections[ind] === "ASC") {
          //         result =
          //           result || typeof a[sortingCols[ind]] === "string"
          //             ? a[sortingCols[ind]].localeCompare(b[sortingCols[ind]])
          //             : a[sortingCols[ind]] - b[sortingCols[ind]];
          //       } else if (sortingDirections[ind] === "DESC") {
          //         result =
          //           result || typeof a[sortingCols[ind]] === "string"
          //             ? b[sortingCols[ind]].localeCompare(a[sortingCols[ind]])
          //             : b[sortingCols[ind]] - a[sortingCols[ind]];
          //       }
          //     } while (ind < sortingCols.length);
          //     return result;
          //   }
          // })
          .sort((a, b) => {
            if (!sortable) return 0;
            for (const col of sortingCols) {
              const dir = sortingDirections[columns.indexOf(col)];
              if (dir === "NON") continue;
              const valA = a[col];
              const valB = b[col];
              let cmp = 0;

              if (typeof valA === "string" && typeof valB === "string") cmp = valA.localeCompare(valB);
              else cmp = (valA ?? 0) - (valB ?? 0);

              if (cmp !== 0) return dir === "ASC" ? cmp : -cmp;
            }
            return 0; // fully equal across all active sort cols
          })
          .map((item, i) => (
            <li className='listrowparent'>
              <li
                tabIndex={-1}
                key={"productrow-" + item[rowID] + "-" + i}
                className={
                  item[rowID] === selectedRowID && clearSelectedRowID !== false
                    ? "listrowQS listrowactive"
                    : "listrowQS"
                }
                onClick={(e) => {
                  if (onRowClick) {
                    onRowClick(item);
                  }
                  setSelectedRowID(item[rowID]);
                  if (setClearSelectedRowID) {
                    setClearSelectedRowID(true);
                  }
                  setClicked(false);
                }}
                onContextMenu={(e) => {
                  e.preventDefault();
                  setClicked(true);
                  setPoints({ x: e.pageX, y: e.pageY });
                  setActiveIndex(i);
                }}
              >
                {rowIndex && <p style={{ width: "35px" }}>{i + 1}</p>}
                {columns.map((col, index) => {
                  if (editing && Object.keys(editing).includes(item[rowID].toString())) {
                    return (
                      <input
                        style={
                          size && size[index] === "S"
                            ? {
                                display: "flex",
                                // flexBasis: 100 / columns.length / 4 + "%",
                                flex: 1,
                              }
                            : size && size[index] === "M"
                            ? {
                                display: "flex",
                                // flexBasis: 100 / columns.length / 2 + "%",
                                flex: 2,
                              }
                            : {
                                display: "flex",
                                // flexBasis: 100 / columns.length + "%",
                                flex: 4,
                              }
                        }
                        onChange={(e) => {
                          setEditing({
                            ...editing,
                            [item[rowID]]: {
                              ...editing[item[rowID]],
                              [col]: e.target.value,
                            },
                          });
                        }}
                        value={editing && editing[item[rowID]] ? editing[item[rowID]][col] : ""}
                        key={"productrow-" + item[rowID] + "-" + i + col}
                      />
                    );
                  } else {
                    return (
                      <p
                        tabIndex={-1}
                        key={"productrow-" + item[rowID] + "-" + i + col}
                        style={
                          size && size[index] === "S"
                            ? {
                                display: "flex",
                                // flexBasis: 100 / columns.length / 4 + "%",
                                flex: 1,
                              }
                            : size && size[index] === "M"
                            ? {
                                display: "flex",
                                // flexBasis: 100 / columns.length / 2 + "%",
                                flex: 2,
                              }
                            : {
                                display: "flex",
                                // flexBasis: 100 / columns.length + "%",
                                flex: 4,
                              }
                        }
                      >
                        {item[col]}
                      </p>
                    );
                  }
                })}
                {editing && editable && Object.keys(editing).includes(item[rowID].toString()) ? (
                  <div className='lwfRowIcons'>
                    <FontAwesomeIcon
                      icon={faSave}
                      className='lwfsaveicon'
                      onClick={(e) => {
                        let { [item[rowID]]: tmp, ...rest } = editing;
                        setEditing(rest);
                      }}
                    />
                    <FontAwesomeIcon icon={faBan} className='lwfsaveicon' />
                    <FontAwesomeIcon icon={faDeleteLeft} className='lwfsaveicon' />
                  </div>
                ) : (
                  editable && (
                    <div className='lwfRowIcons'>
                      <FontAwesomeIcon
                        icon={faBars}
                        className='lwfsaveicon'
                        onClick={(e) => {
                          addRowToEditing(item);
                        }}
                      />
                    </div>
                  )
                )}
              </li>
              <div className='lwf-custom-context'>
                {clicked && activeIndex === i && (
                  <div className='contextMenu'>
                    <ul onContextMenu={(e) => e.preventDefault()}>
                      <li
                        onClick={(e) => {
                          // setEditingPCN(true);
                          setClicked(false);
                          // console.log(item[rowID]);
                          duplicateQS(item[rowID]);
                          // setSelectedProdName("");
                          // setShowProdDetails("");
                          // setSelectedProduct(null);
                          // setSelectedProducer("");
                          // setProdCatNameEdits({
                          //   ["prodCatNameID"]: singleProdGroupData[key][0]["prodCatNameID"],
                          //   ["prodCatName"]: key,
                          // });
                        }}
                      >
                        Duplicate
                      </li>
                      {/* <li>Delete</li> */}
                    </ul>
                  </div>
                )}
              </div>
            </li>
          ))}
    </ul>
  );
};

export default ListWithFilters;
